import { View } from 'react-native';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { spacing } from '@tabbio/tokens';
import { NativeButton } from '../common/NativeButton';
import { fetchCvLanguageVariants } from '../../lib/cv-collaboration-api';
import { cvReviewEnabled } from '../../lib/cv-release-api';

export function CvEditionSelector({ target, value, onChange, disabled = false }: {
  target: string; value: string | null; onChange(value: string | null): void; disabled?: boolean;
}) {
  const { t } = useTranslation('seeker');
  const variants = useQuery({ queryKey: ['cv', target, 'variants'], queryFn: () => fetchCvLanguageVariants(target), enabled: cvReviewEnabled && Boolean(target) });
  if (!cvReviewEnabled) return null;
  return <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: spacing[2] }}>
    <NativeButton title={t('cv.review.original')} variant={value === null ? 'solid' : 'outline'} size="sm" disabled={disabled}
      accessibilityRole="radio" accessibilityState={{ checked: value === null }} onPress={() => onChange(null)} />
    {(variants.data ?? []).map((variant) => <NativeButton key={variant.id} title={t(`cv.review.locale.${variant.locale}`, { defaultValue: variant.locale })}
      variant={value === variant.id ? 'solid' : 'outline'} size="sm" disabled={disabled} accessibilityRole="radio"
      accessibilityState={{ checked: value === variant.id }} onPress={() => onChange(variant.id)} />)}
  </View>;
}
